export function loadRecaptchaV3(siteKey: string) {
    if (!window.grecaptcha) {
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`
        script.async = true;
        document.head.appendChild(script);
    }
}

export async function getRecaptchaTokenV3(siteKey: string) {
    if (!window.grecaptcha) {
        throw new Error("reCAPTCHA script not loaded");
    }

    return await window.grecaptcha.execute(siteKey);
}
